import {
  ACTION_PUT_UPDATE_BOOKING,
  ACTION_PUT_UPDATE_BOOKING_SUCCESS,
  ACTION_PUT_UPDATE_BOOKING_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../Status';

type HotelAddress = {
  street?: string;
  city?: string;
  state?: string;
  countryCode?: string;
  postalCode?: string;
};

export type UpdateBookingParams = {
  bookingId: string;
  status?: string;
  confirmationNumber?: string;
  userEmail?: string;
  notes?: string;
  segments?: any[];
  travelerIds?: string[];
  basePrice?: number;
  totalPrice?: number;
  requiredCharges?: number;
  providerReturnDate?: string;
  // --- HOTEL BOOKING FIELDS ---
  taxesAndFees?: number;
  customerPrice?: number;
  resortFee?: number;
  checkInDate?: string;
  checkInTime?: string;
  checkOutDate?: string;
  checkOutTime?: string;
  roomType?: string;
  bedType?: string;
  cancellationPolicy?: string;
  hotelName?: string;
  hotelAddress?: HotelAddress;
  // Flight pricing / date fields
  taxPrice?: number;
  reservationStartDate?: string;
  endDate?: string;
  dropOffDate?: string;
  onSuccess?: () => void;
};

export function updateBooking(data: UpdateBookingParams) {
  const { onSuccess, ...payload } = data;
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `bookings/details`,
        method: 'put',
        data: JSON.stringify(payload) || {},
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            enqueueSnackbarHandler(
              dispatch,
              { updateBookingDetailsFailure: true },
              'error',
            );
          } else {
            dispatch(requestSuccess(response));
            enqueueSnackbarHandler(
              dispatch,
              { updateBookingDetailsSuccess: true },
              'success',
            );
            onSuccess?.();
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          enqueueSnackbarHandler(
            dispatch,
            { updateBookingDetailsFailure: true },
            'error',
          );
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_UPDATE_BOOKING,
    payload: null,
  };
}

export function requestSuccess(responseJSON: any) {
  return {
    type: ACTION_PUT_UPDATE_BOOKING_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: any) {
  return {
    type: ACTION_PUT_UPDATE_BOOKING_FAILURE,
    payload: responseJSON,
  };
}
